import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';
import { head } from '@/router/Head';

export const Route = createFileRoute('/_authenticated/_dashboard/preferences')({
  staticData: {
    title: 'Preferences',
    domain: 'account',
  },
  head,
  component: lazyRouteComponent(() => import('./preferences.component'), 'PreferencesComponent'),
});
